exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".user-filter-component[data-v-a24b0a70]{position:relative}.select-component[data-v-a24b0a70]{float:left;min-width:300px!important;margin-top:-5px}.user-filter-value[data-v-a24b0a70]{margin-bottom:3px;min-width:400px!important}.add-button[data-v-a24b0a70]{margin-left:3px;margin-top:-4px}.errorClass[data-v-a24b0a70]{border:1px solid red}label[data-v-a24b0a70]{font-size:.8em}.save-panel button[data-v-a24b0a70]{border-radius:12px}.save-panel[data-v-a24b0a70]{position:absolute;top:0;right:0;background-color:#fff;padding:15px;border-radius:12px;z-index:99999!important;border-left:5px solid #48e04a;box-shadow:10px 12px 10px 6px #0000003f}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-a24b0a70&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UserFilterComponent.vue
// module id = 928
// module chunks = 2